<template>
    <div class="configura-campos">
        <div class="novos-campos">
            <v-draggable :list="campos" handle=".p-handle">
                <Campos
                    ref="campo"
                    v-for="(c, i) in campos"
                    :key="c.idpergunta"
                    :pergunta="c"
                    :index="i"
                    :expandir="!c.idpergunta"
                    :copiar-pergunta="copiarPergunta"
                />
            </v-draggable>
            <!-- </Container> -->
        </div>
        <button type="button" class="btn add-campos" @click="addCampo()">
            <p>
                <svg class="svg-icons">
                    <use
                        :xlink:href="require('@/assets/img/icons/shape-plus.svg') + '#layer'"
                    ></use>
                </svg>
                {{ $t('adicionar-novo-campo') }}
            </p>
        </button>
    </div>
</template>

<script>
import Campos from '@/components/promotor/formulario/old/abas/Campo.vue';

/**
 * @deprecated Essa classe foi depreciada e nao devera ser usada.
 */
export default {
    components: {
        Campos,
    },
    props: {
        campos: {
            type: Array,
            default: () => [],
        },
        index: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            // Formulario.vue
            formulario: this.$parent.$parent,
        };
    },
    created() {
        this.$on('copiar-pergunta', this.copiarPergunta);
        this.$on('excluir-pergunta', this.excluirPergunta);
        this.$on('update-pergunta', this.updatePergunta);
        this.campos.map((c) => {
            c.datahoradel = null;
            return { ...c };
        });
    },
    methods: {
        addCampo() {
            this.campos.push({
                datahoradel: null,
                obrigaresposta: 0,
                gruporespostas: [
                    {
                        tipo: 'TEXT',
                        respostas: [],
                    },
                ],
            });
            // this.$emit("updated-campos", this.campos);
            this.emitGrupoPergunta();
        },
        copiarPergunta(i) {
            let novaPergunta = JSON.parse(JSON.stringify(this.campos[i]));
            novaPergunta.idpergunta = null;
            novaPergunta.gruporespostas.forEach((gr) => {
                gr.idgruporesposta = null;
                gr.idpergunta = null;
            });
            this.campos.push(Object.assign({}, novaPergunta));
            this.emitGrupoPergunta();
        },
        excluirPergunta(i) {
            this.campos[i].datahoradel = new Date();
            let novaPergunta = JSON.parse(JSON.stringify(this.campos[i]));
            // Tem que fazer isso para o componente Campo poder detectar a mudança da datahoradel
            this.campos.splice(i, 1, Object.assign({}, novaPergunta));
            this.emitGrupoPergunta();
        },
        updatePergunta(p, i) {
            this.emitGrupoPergunta(i);
        },
        emitGrupoPergunta(i) {
            setTimeout(() => {
                this.formulario.$emit('update-grupoperguntas', this.campos, this.index);
            }, 200);
        },
    },
};
</script>

<style lang="scss" scoped>
.configura-campos {
    width: 100%;
    margin-top: 15px;

    > .novos-campos {
        margin-bottom: 20px;
        position: relative;

        .campo.campo-not-expanded + .campo.campo-not-expanded {
            border-top: none;
        }
    }

    > .add-campos {
        @include exclude-button();
        position: relative;
        border-radius: 10px;
        padding: 10px 80px;
        text-align: center;
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        margin-left: calc(50% - 177px);

        > p {
            display: flex;
            align-items: center;
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: $darker-gray-color;

            > svg {
                margin-right: 10px;
                fill: $light-gray-color;
            }
        }
    }
}
</style>
